module.exports = __webpack_public_path__ + "img/school.e0da5a9f.svg";